<template>
  <div class="input-group" :class="{open: open}">
    <label @click=toggle>{{ 'feelgrid:devices.select.label' | trans }}</label>
    <div class="value form-control">
      <ins v-if="value.length" @click=toggle>{{ chosen_names.join(', ') | text }}</ins>
      <ins v-else class="faded" @click=toggle>{{ 'feelgrid:devices.select.none' | trans }}</ins>
      <ul class="drop" v-if="open">
        <li class="all">
          <label class="checkbox sm" @click="all">
            <span>{{ 'feelgrid:devices.select.all' | trans }}</span>
          </label>
        </li>
        <li v-for="device in devices">
          <label class="checkbox sm">
            <input type="checkbox" :value="device.item.id" v-model="selected" />
            <i></i>
            <span>{{ device.name | text }}</span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {event_hit} from '@/helpers/util'

  export default {
    name: 'DeviceSelector',
    props: {
      value: {required: true},
      devices: {required: true},
    },
    data() {return {
      open: false,
    }},
    computed: {
      chosen_names () {
        return this.devices
          .filter(d => this.value.includes(d.item.id))
          .map(d => d.name)
        ;
      },
      selected: {
        get () {
          return this.value;
        },
        set (v) {
          this.$emit('input', v);
        },
      },
    },
    methods: {
      all () {
        this.selected = this.devices.map(d => d.item.id);
      },
      toggle () {
        this.open = !this.open;
      },
      listener (evt) {
        if (event_hit(evt, this.$el)) {
          return;
        }
        this.open = false;
      },
    },
    mounted () {
      document.addEventListener('click', this.listener);
    },
    beforeDestroy () {
      document.removeEventListener('click', this.listener);
    }
  }
</script>

<style lang="scss" scoped>
  @import '../scss/variables';

  .input-group {
    position: relative;
    &.open {
      border-bottom-left-radius: 0;
      &, .form-control {
        border-bottom-right-radius: 0;
      }
    }
    label, ins {
      cursor: pointer;
      text-align: left;
    }
    label span {
      color: $default-color;
    }
    ins {
      position: relative;
      display: block;
      @media (min-width: $sm-min) {
        width: 200px;
      }
      padding-right: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-decoration: none;
      &::after {
        position: absolute;
        display: inline-block;
        top: 0;
        right: 2px;
        content: ' \25bc';
        color: $green;
      }
    }
    .form-control {
      padding-left: 10px;
      padding-right: 10px;
    }
    ul.drop {
      position: absolute;
      z-index: 1;
      left: 0;
      right: 0;
      top: 100%;
      background: white;
      border: solid $green 2px;
      border-top: none;
      border-radius: 0 0 $panel-radius $panel-radius;
      padding: 6px 0;
      li {
        padding: 2px;
        text-align: left;
        label {
          display: block;
          &:hover span {
            text-decoration: underline;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/apps/feelgrid/assets/DeviceSelector.vue